import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import {
    ClassificacaoDocumentoInterface,
    TipoDocumentoInterface,
} from "../../../../../../Interfaces/Geral/GestaoDeCadastro/TipoDocumento/TipoDocumentoInterface";
import {
    CadastratarTipoDocumentoController,
    DeletarTipoDocumentoController,
    ListarClassificacaoDocumentoController,
    ListarTipoDocumentoController,
} from "../../../../../../Controllers/Geral/GestaoDeCadastros/TipoDocumento/TipoDocumentoController";
import "./styles.css";

import Table from "../../../../../Table";
import { ColumnDescription } from "react-bootstrap-table-next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import SpinnerComponent from "../../../../../Loding/Spinner";

interface TipoDocumentoFormData {
    DS_TIPO_DOCUMENTO: string;
    ID_CLASSIFICACAO_DOCUMENTO: number;
}

export default function TipoDocumento() {
    const { register, handleSubmit, formState, reset } = useForm();

    const [lstTipoDocumento, setLstTipoDocumento] = useState(
        [] as Array<TipoDocumentoInterface>
    );
    const [lstClassificaoDocumento, setLstClassificaoDocumento] = useState(
        [] as Array<ClassificacaoDocumentoInterface>
    );

    useEffect(() => {
        updateListaTipoDocumento();

        ListarClassificacaoDocumentoController().then((res) => {
            setLstClassificaoDocumento(res);
        });
    }, []);

    function updateListaTipoDocumento() {
        ListarTipoDocumentoController().then((response) => {
            setLstTipoDocumento(response);
        });
    }

    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_TIPO_DOCUMENTO",
            text: "Tipo Documento",
            formatter: rowTipoDocumento,
        },
    ];

    function rowTipoDocumento(cell: string, row: TipoDocumentoInterface) {
        return (
            <div className="rowCapysTR d-flex justify-content-between align-items-center">
                <div>
                    <label className="mb-1">{row.DS_TIPO_DOCUMENTO}</label>
                    <div>
                        {row.DS_CLASSIFICACAO_DOCUMENTO && (
                            <span
                                className={`label abel-pill label-inline label-primary`}
                            >
                                {row.DS_CLASSIFICACAO_DOCUMENTO}
                            </span>
                        )}
                    </div>
                </div>
                <div>
                    <button
                        className="btn  btn-sm btn-outline-danger font-weight-bold"
                        onClick={() => {
                            Swal.fire({
                                title: "Deseja apagar este documento?",
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    DeletarTipoDocumentoController(
                                        row.ID_TIPO_DOCUMENTO
                                    ).then(() => {
                                        updateListaTipoDocumento();
                                    });
                                }
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} size="lg" />
                    </button>
                </div>
            </div>
        );
    }

    const handleTipoDocumentoFormSubmit = (formData: TipoDocumentoFormData) => {
        CadastratarTipoDocumentoController({
            DS_TIPO_DOCUMENTO: formData.DS_TIPO_DOCUMENTO,
            ID_CLASSIFICACAO_DOCUMENTO: formData.ID_CLASSIFICACAO_DOCUMENTO,
        }).then(() => {
            updateListaTipoDocumento();
            reset();
        });
    };

    return lstClassificaoDocumento.length && lstTipoDocumento.length ? (
        <>
            <div className="Row1 d-flex flex-columns row">
                <div className="col-12 collapse mb-5" id="collapseForm">
                    <h5 className="text-center">Cadastre Tipo de Documento</h5>
                    <form
                        onSubmit={handleSubmit(handleTipoDocumentoFormSubmit)}
                        className="w-100 w-100 h-100"
                    >
                        <div className="row mb-3">
                            <div className="col-12 col-lg-6">
                                <input
                                    type="text"
                                    name="DS_TIPO_DOCUMENTO"
                                    placeholder="Tipo do Documento"
                                    className={`form-control placeholder-dark-45 h-100 ${
                                        formState.errors.DS_TIPO_DOCUMENTO &&
                                        "is-invalid"
                                    }`}
                                    ref={register({
                                        required: "Insira o tipo do documento",
                                    })}
                                />
                            </div>
                            <div className="col-12 col-lg-6">
                                <select
                                    key={"keyprop"}
                                    className={`form-control placeholder-dark-45 h-100 ${
                                        formState.errors.value && "is-invalid"
                                    }`}
                                    name="ID_CLASSIFICACAO_DOCUMENTO"
                                    ref={register({ required: true })}
                                >
                                    <option key={"keypropOption"} value="">
                                        Selecione a classificação do documento
                                    </option>
                                    {lstClassificaoDocumento.map(
                                        (res, index) => {
                                            return (
                                                <option
                                                    value={
                                                        res.ID_CLASSIFICACAO_DOCUMENTO
                                                    }
                                                    key={index}
                                                >
                                                    {
                                                        res.DS_CLASSIFICACAO_DOCUMENTO
                                                    }
                                                </option>
                                            );
                                        }
                                    )}
                                </select>
                            </div>
                            <div className="col-12 mt-3">
                                <button className="btn btn-outline-success font-weight-bold w-100">
                                    <FontAwesomeIcon icon={faPlus} size="lg" />{" "}
                                    Cadastrar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>

                <div className="col-12 mt-1">
                    <Table
                        keyField="ID_TIPO_DOCUMENTO"
                        columns={columns}
                        data={lstTipoDocumento}
                        sizePerPage={5}
                    />
                </div>
            </div>
        </>
    ) : (
        <SpinnerComponent />
    );
}
